import { createReducer, on } from '@ngrx/store';
import * as TaskReferenceActions from './task-reference.actions';
import type { TaskReferenceState } from './task-reference.models';

export const initialState: TaskReferenceState = {
  items: [],
  loading: false,
  error: null,
};

export const taskReferenceReducer = createReducer(
  initialState,
  on(TaskReferenceActions.TaskReferenceLoadRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TaskReferenceActions.TaskReferenceLoadSuccess, (state, { items }) => ({
    ...state,
    items,
    loading: false,
    error: null,
  })),
  on(TaskReferenceActions.TaskReferenceLoadFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
